import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	resultLabel: {
		id: 'github-branch-result.label',
		defaultMessage: 'Branch',
		description: 'GitHub branch label',
	},
});
